export default function () {
  return {
    project_id: "alexandra-1109B"
  }
}



// WEBPACK FOOTER //
// ./src/services/prefix/reducer.js